import React from 'react';
import PrimaryCustomButton from '../../primary-custom-button/primary-custom-button.component';
// adjust path if needed

const SubscribeBox = ({ subscribeSection }) => {
  return (
    <div className="subscribe-box">
      <div className="subscribe-text">
        <h3>{subscribeSection.title}</h3>
        <p>{subscribeSection.description}</p>
      </div>
      <PrimaryCustomButton
        href={subscribeSection.cta.href}
        title={subscribeSection.cta.text}
        customClass={'style-primary-button'}
      />
    </div>
  );
};

export default SubscribeBox;
